<template>
    <div>
        <a-row>
            <a-col :span="24">
                <mavon-editor
                    v-model="content"
                    ref="md"
                    @change="change"
                    @imgAdd="imgAdd"
                    @save="save"
                    style="min-height: 600px; max-height: 1000px;"
                />
            </a-col>
            <a-col :span="24">
                <div style="margin: 20px 0 50px 0;">
                    <a-button type="primary" @click="goBack">
                        返回产品列表
                    </a-button>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import {mavonEditor} from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

export default {
    name: "ProContent",
    data() {
        return {
            content: '', // 输入的markdown
            html: '',    // 及时转的html
            uploadHost: '',
            uploadData: {},
        }
    },
    components: {
        mavonEditor,
    },
    methods: {
        picSignature(pos) {
            let that = this
            return this.$ajax.get(this.$host+"/admin/pic/uploadSig", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.uploadHost = 'https://'+result.data.host;

                    that.uploadData[pos] = {};
                    that.uploadData[pos].key = result.data.path;
                    that.uploadData[pos].policy = result.data.policy;
                    that.uploadData[pos].OSSAccessKeyId = result.data.accessId;
                    that.uploadData[pos].signature = result.data.signature;
                }else{
                    return Promise.reject();
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        imgAdd(pos,$file){
            let that = this;
            let formdata = new FormData();
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-oss-object-acl': 'public-read'
                }
            }
            this.picSignature(pos).then(function () {
                formdata.append('key',that.uploadData[pos].key);
                formdata.append('policy',that.uploadData[pos].policy);
                formdata.append('OSSAccessKeyId',that.uploadData[pos].OSSAccessKeyId);
                formdata.append('signature',that.uploadData[pos].signature);
                formdata.append('file', $file);
                that.$ajax.post(that.uploadHost, formdata, config).then(() => {
                    that.$refs.md.$img2Url(pos, that.uploadHost + "/" + that.uploadData[pos].key);
                }).catch(err => {
                    console.log(err)
                })
            });
        },
        // 所有操作都会被解析重新渲染
        change(value, render) {
            // render 为 markdown 解析后的结果[html]
            this.html = render;
        },
        save() {
            let that = this;
            let formdata = new FormData();
            formdata.set('content',this.content);
            formdata.set('html',this.html);
            formdata.set('product',this.$route.params.product);
            this.$ajax.post(this.$host+"/admin/pro/content/update", formdata).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.$message.info("保存成功");
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        goBack() {
            this.$router.push({path: "/admin/pro"});
        },
        getContent() {
            let that = this;
            this.$ajax.get(this.$host+"/admin/pro/content/get", {
                params: {
                    product:this.$route.params.product
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200 && result.data!==null) {
                    that.content = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.getContent();
    }
}
</script>

<style scoped>

</style>